<template>
  <div>
    <div v-if="loading" class="border rounded p-3 d-flex align-items-center">
      <i class="el-icon-loading mr-2"></i>
      Carregando dados...
    </div>

    <div v-if="perfil && !loading">
      <b-row align-v="end">
        <b-col>
          <b-button variant="primary" size="sm" @click="verTodos()"><i class="fa fa-list" /> Ver Todos</b-button>
        </b-col>
        <b-col class="text-right">
          <b-button title="Solicitar Atualização de Cadastro" style="background-color: blueviolet; color: aliceblue" v-if="
            (perfil == 'adm' || perfil === 'coord-comercial' || perfil === 'cobranca') &&
            dadosFormulario.configuracoes.status === 'ATIVO' &&
            (dadosFormulario.configuracoes.classe_distribuidor == 'G' ||
              dadosFormulario.configuracoes.classe_distribuidor == 'A')
          " class="mr-2" size="sm" @click="atualizarCadastro">
            <i class="fas fa-sync-alt"></i> Solicitar Atualização
          </b-button>
        </b-col>
        <b-col class="text-right" v-if="acao != 'ver'">
          <b-button v-if="
            acao != 'ver' && dadosFormulario.configuracoes.status !== 'ATIVO'
          " variant="primary" class="mr-2" size="sm" :disabled="loadingSave" @click="saveFormularios">
            <i class="fa fa-save" v-if="!loadingSave"></i>
            <div v-if="loadingSave" class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            Salvar
          </b-button>
          <b-button variant="success" class="mr-2" size="sm"  @click="ativaCadastro" v-if="
            (perfil === 'financeiro' || perfil === 'adm' || perfil === 'cobranca') &&
            dadosFormulario.configuracoes.status === 'AGUARDANDO' && anexosAprovados"
          title="Salvar e Aprovar">
            <i class="fa fa-thumbs-up"></i> Aprovar
          </b-button>
          <b-button variant="third" class="mr-2" size="sm" @click="pendenciarCadastro" v-if="
            ((perfil === 'financeiro' || perfil === 'adm' || perfil === 'cobranca') &&
              dadosFormulario.configuracoes.status === 'AGUARDANDO') ||
            dadosFormulario.configuracoes.status === 'PRE-CADASTRO'
          " title="Salvar e Pendenciar">
            <i class="fas fa-undo"></i> Pendenciar
          </b-button>
          <b-button v-if="
            (perfil === 'financeiro' ||
              perfil === 'adm' ||
              perfil === 'coord-comercial' || 
              perfil === 'cobranca') &&
            !dadosFormulario.configuracoes.codigo_distribuidor &&
            (dadosFormulario.configuracoes.status === 'AGUARDANDO' ||
              dadosFormulario.configuracoes.status === 'DIGITADO' ||
              dadosFormulario.configuracoes.status === 'PENDENTE')
          " variant="danger" class="mr-2" size="sm" @click="inativarCadastro" title="Salvar e Inativar">
            <i class="fas fa-window-close"></i> Inativar
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card class="mt-2">
            <b-card-body>
              <b-row class="mb-2">
                <b-col cols="9">
                  <h5>
                    Formulário Prospecto
                    <b>
                      <span v-if="dadosFormulario.empresa.nome_fantasia">| {{ dadosFormulario.empresa.nome_fantasia
                        }}</span>
                      <span v-if="dadosFormulario.configuracoes.codigo_distribuidor">
                        - {{ dadosFormulario.configuracoes.codigo_distribuidor }}
                      </span>
                    </b>
                  </h5>
                </b-col>
                <b-col cols="3" class="text-right">
                  <h4>
                    <b-badge v-if="
                      dadosFormulario.configuracoes.status === 'PRE-CADASTRO'
                    " variant="third">PRE-CADASTRO</b-badge>
                    <b-badge v-else-if="
                      dadosFormulario.configuracoes.status === 'DIGITADO'
                    " variant="primary">DIGITADO</b-badge>
                    <b-badge v-else-if="
                      dadosFormulario.configuracoes.status === 'AGUARDANDO'
                    " variant="warning">AGUARDANDO</b-badge>
                    <b-badge v-else-if="
                      dadosFormulario.configuracoes.status === 'INATIVO'
                    " variant="danger">INATIVO</b-badge>
                    <b-badge v-else-if="dadosFormulario.configuracoes.status === 'ATIVO'"
                      variant="success">ATIVO</b-badge>
                    <b-badge v-else-if="
                      dadosFormulario.configuracoes.status === 'PENDENTE'
                    " variant="danger">PENDENTE</b-badge>
                  </h4>
                </b-col>
              </b-row>
              <b-row v-if="(perfil === 'financeiro' || perfil === 'adm' || perfil === 'cobranca') && prospectoId > 0 && duplicatasEncontradas.length > 0" class="mt-1 mb-1">
                <b-col>
                  <b-alert variant="warning" show class="mb-0 d-flex align-items-center justify-content-between py-2">
                    <span>
                      <i class="fas fa-exclamation-triangle mr-1"></i>
                      <strong>Atenção:</strong> {{ duplicatasEncontradas.length }} outro(s) cadastro(s) possuem telefone ou endereço coincidentes com este cadastro.
                    </span>
                    <b-button size="sm" variant="warning" class="ml-3 flex-shrink-0" @click="modalDuplicatas = true">
                      <i class="fas fa-search"></i> Ver Cadastros
                    </b-button>
                  </b-alert>
                </b-col>
              </b-row>
              <b-row align-v="end">
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="">Tipo de Cadastro:</label>
                    <select name="" id="" class="form-control" v-model="dadosFormulario.configuracoes.tipo_cadastro"
                      @change="
                        changeTipoCadastro(
                          dadosFormulario.configuracoes.tipo_cadastro
                        )
                      ">
                      <option value="NOVO">Novo</option>
                      <option value="MIGRACAO" v-if="perfil == 'coord_comercial' || perfil == 'cobranca' || perfil == 'financeiro' || perfil == 'comercial' || perfil == 'adm' || dadosFormulario.configuracoes.tipo_cadastro === 'MIGRACAO'">Migração</option>
                      <option value="REATIVACAO">Reativação</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="">Região:</label>
                    <b-select :options="showRegioes" value-field="id" text-field="label"
                      v-model="dadosFormulario.configuracoes.regiao_id" :disabled="perfil === 'centro_distribuicao'">
                    </b-select>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <b-form-group label="Classe Distribuidor:" label-for="classe-distribuidor">
                      <b-form-select id="classe-distribuidor" @change="showKit && changeTipoPagamento" :disabled="dadosFormulario.configuracoes.status !==
                        'PRE-CADASTRO' &&
                        dadosFormulario.configuracoes.status !== 'DIGITADO' &&
                        dadosFormulario.configuracoes.status !== 'PENDENTE' &&
                        dadosFormulario.configuracoes.status !== 'AGUARDANDO' &&
                        prospectoId > 0
                        " v-model="dadosFormulario.configuracoes.classe_distribuidor
                          " :options="showOptionsClasse">
                      </b-form-select>
                    </b-form-group>
                  </div>
                </div>
                <div class="col-md-3" v-if="dadosFormulario.configuracoes.classe_distribuidor !== 'V'">
                  <div class="form-group">
                    <div class="form-group">
                      <b-form-group label="Consultor:">
                        <b-form-select :disabled="dadosFormulario.configuracoes.status !== 'DIGITADO' &&
                          propProspectoId > 0 &&
                          consultorValido
                          " v-model="dadosFormulario.configuracoes.codigo_vendedor" :options="showOptionsConsultor">
                        </b-form-select>
                      </b-form-group>
                    </div>
                  </div>
                </div>
                <div class="col-md-3" v-else>
                  <div class="form-group">
                    <div class="form-group">
                      <b-form-group label="Gerente:">
                        <b-form-select :disabled="dadosFormulario.configuracoes.status !== 'DIGITADO' &&
                          propProspectoId > 0 &&
                          consultorValido
                          " v-model="dadosFormulario.configuracoes.codigo_vendedor" :options="showOptionsGerente">
                        </b-form-select>
                      </b-form-group>
                    </div>
                  </div>
                </div>
                <div class="col-md-3" v-if="
                  dadosFormulario.configuracoes.classe_distribuidor == 'V' &&
                  (perfil === 'adm' ||
                    perfil === 'representante_varejo' ||
                    perfil === 'gerente_varejo' ||
                    perfil === 'list_prospecto' ||
                    perfil === 'analista_farma' ||
                    perfil === 'supervisor_externo' ||
                    perfil === 'diretor_nacional' ||
                    perfil === 'gerente_nacional' ||
                    perfil === 'gerente_regional' ||
                    perfil === 'gerente_distrital' ||
                    perfil === 'cobranca'
                  )
                ">
                  <div class="form-group">
                    <label for="">Representante:</label>
                    <b-form-select :disabled="dadosFormulario.configuracoes.status !== 'DIGITADO' ||
                      (representante !== '' &&
                        perfil !== 'adm' &&
                        perfil !== 'gestor_varejo' &&
                        perfil !== 'list_prospecto' &&
                        perfil !== 'supervisor_externo' &&
                        perfil !== 'cobranca')
                      " v-model="representante" :options="representantes"></b-form-select>
                  </div>
                </div>
              </b-row>
              <b-row align-v="start" class="mt-3">
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="">Centro de Distribuição:</label>
                    <b-form-select :disabled="dadosFormulario.configuracoes.status !== 'DIGITADO'" v-model="dadosFormulario.configuracoes.centro_distribuicao"
                      :options="listaCentroDistribuicao" @change="setCd()">
                    </b-form-select>
                  </div>
                </div>
                <div class="col-md-2" v-if="perfil == 'adm'">
                  <div class="form-group">
                    <label for="">Usuário</label>
                    <select class="form-control" name="" id="" v-model="dadosFormulario.configuracoes.user_id">
                      <option v-for="(user, u) in users" :value="user.id" :key="u">
                        {{ user.name }} ({{ getRolesUser(user.roles) }})
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-md-6 mt-3" v-if="dadosFormulario.configuracoes.centro_distribuicao == 10">
                  <b-form-group v-slot="{ ariaDescribedby }">
                    <b-form-radio-group :disabled="prospectoId > 0" id="radio-group-1" v-model="tipoCadastro"
                      :options="optionsRadio" :aria-describedby="ariaDescribedby"
                      name="radio-options"></b-form-radio-group>
                  </b-form-group>
                </div>
                <b-col class="col-md-2" v-if="dadosFormulario.configuracoes.tipo_cadastro == 'MIGRACAO' || dadosFormulario.configuracoes.tipo_cadastro == 'REATIVACAO'">
                  <div class="form-group">
                    <label for="">Código Anterior</label>
                    <v-busca-distribuidor v-if="!dadosFormulario.configuracoes.codigo_anterior" label_text=""
                      v-model="dadosFormulario.configuracoes.codigo_anterior" />
                    <div v-else>
                      <strong>
                        {{ dadosFormulario.configuracoes.codigo_anterior.codigo }}
                      </strong>
                      <a href="#" @click="removeAnterior()"><i class="fas fa-times"></i>
                      </a>
                    </div>
                  </div>
                </b-col>
                <b-col class="col-md-6">
                  <label>Indicado Por:</label>
                  <v-select v-model="indicanteSelecionado" :options="listaDistribuidores" @search="buscaDistribuidor"
                    @change="selectIndicante" placeholder="Código do Distribuidor" v-mask="['#######']" :disabled="loadingBuscaDistribuidor ||
                      (dadosFormulario.configuracoes.status !== 'DIGITADO' &&
                        dadosFormulario.configuracoes.status !== 'PENDENTE') ||
                      dadosFormulario.configuracoes.tipo_cadastro != 'NOVO'
                      ">
                    <div slot="no-options">Nenhum distribuidor encontrado</div>
                  </v-select>
                </b-col>
              </b-row>
              <b-tabs content-class="mt-3" fill active-tab-class="font-weight-bold bg-secondary text-primary" class="prospect-menu" card>
                <b-tab :title="!tipoCadastro ? 'Empresa' : 'Cliente'" title-item-class="bg-primary text-secondary" class="prospect-menu" active>
                  <b-card>
                    <b-card-header>
                      <span v-if="!tipoCadastro">Dados da Empresa</span>
                      <span v-else>Dados do Cliente</span>
                    </b-card-header>
                    <b-card-body>
                      <b-row align-v="center">
                        <b-col cols="6">
                          <div class="checkbox" v-if="!tipoCadastro">
                            <label><input type="checkbox" v-model="dadosFormulario.empresa.cadastro_mei" />
                              Cadastrado MEI</label>
                          </div>
                        </b-col>
                        <b-col cols="6">
                          <div class="checkbox" v-if="!tipoCadastro">
                            <label>
                              <input 
                                type="checkbox"
                                v-model="dadosFormulario.empresa.assinado_gov"
                              />
                              Assinado via Gov?
                            </label>
                          </div>
                        </b-col>

                      </b-row>
                      <div class="row" v-if="!tipoCadastro">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="">Razão Social:</label>
                            <input type="text" class="form-control" v-model="dadosFormulario.empresa.razao_social" />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="">Nome Fantasia:</label>
                            <input type="text" class="form-control" v-model="dadosFormulario.empresa.nome_fantasia" />
                          </div>
                        </div>
                      </div>
                      <div class="row" v-if="!tipoCadastro">
                        <!-- CNPJ -->
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>CNPJ:</label>
                            <input 
                              v-model="dadosFormulario.empresa.cnpj" 
                              type="text" 
                              class="form-control" 
                              v-mask="['##.###.###/####-##']"
                              placeholder="00.000.000/0001-00"
                            />
                            <vConsultaReceitaFederal :cnpj="dadosFormulario.empresa.cnpj">
                            </vConsultaReceitaFederal>
                          </div>
                        </div>
                        
                        <!-- Inscrição estadual -->
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="">Inscrição Estadual:</label>
                            <!-- @focusout="verificarInscricaoEstadual" -->
                            <input type="text" :class="{
                              error:
                                dadosFormulario.empresa.inscricao_estadual
                                  .length > 3 && invalidInscricao,
                            }" class="form-control" v-model="dadosFormulario.empresa.inscricao_estadual" />
                            <div class="text-danger" v-if="erroInscricao && invalidInscricao && !loadingIsncricao">{{ erroInscricao }}</div>
                            <div v-if="loadingIsncricao">Verificando Inscrição...</div>
                          </div>
                        </div>

                        <!-- Email -->
                        <div 
                          class="col-md-4" 
                          v-if="dadosFormulario.proprietario != null"
                        >
                          <label>E-Mail</label>
                          <input 
                            v-model="dadosFormulario.proprietario.email" 
                            type="email"
                            placeholder="Ex: exemplo@email.com"
                            class="form-control"
                          />
                        </div>

                      </div>

                      <!-- Contatos da empresa -->
                      <el-row v-if="!tipoCadastro" class="mb-4" :gutter="12">
                        <el-col :span="24" class="mb-2">
                          <strong>Contatos da Empresa:</strong>
                        </el-col>
                        <el-col>
                          <el-row :gutter="12">
                            <el-col 
                              v-for="(contato, index) in dadosFormulario.empresa.contatos" 
                              :span="12"
                              :key="index"
                              class="mb-3"
                            >
                              <v-contato 
                                :id="index" 
                                v-model="dadosFormulario.empresa.contatos[index]" 
                                backgroundColor="#f0eeee" 
                                :removable="dadosFormulario.empresa.contatos.length > 2"
                                ref="contatoEmpresa"
                                @delete="deleteContatoEmpresa"
                              />
                            </el-col>
                          </el-row>
                        </el-col>

                        <el-col class="col-4">
                          <el-button 
                            type="primary" 
                            size="medium"
                            plain
                            @click="addContato(dadosFormulario.empresa.contatos)"
                          >
                            <i class="fa fa-plus mr-1"></i> 
                            Adicionar contato
                          </el-button>
                        </el-col>
                      </el-row>

                      <!-- Enderecos -->
                      <el-row :gutter="12">
                        <!-- Principal -->
                        <el-col :span="12">
                          <div class="mb-4">
                            <strong v-if="!tipoCadastro">Endereço da Empresa:</strong>
                            <strong v-else>Endereço do Cliente:</strong>
                          </div>

                          <el-row v-if="(!loading || (acao == 'import' && !loadingImport)) && perfil">
                            <el-col>
                              <vEndereco 
                                v-model="dadosFormulario.empresa.endereco"
                                ref="enderecoEmpresa" 
                                @prazos="prazos"
                              />
                            </el-col>
                          </el-row>
                        </el-col>

                        <!-- Entrega -->
                        <el-col :span="12">
                          <div class="d-flex align-items-center justify-content-between mb-4">
                            <strong>Endereço de Entrega:</strong>

                            <div class="form-group mb-0">
                              <div class="checkbox">
                                <label class="mb-0">
                                  Usar o mesmo Endereço
                                  <input type="checkbox" @change="copiarEnderecoParaEntrega" v-model="copyEnderecoEntrega" />
                                </label>
                              </div>
                            </div>
                          </div>

                          <div 
                            class="row" 
                            :style="{
                              pointerEvents: !copyEnderecoEntrega ? 'auto' : 'none',
                              opacity: !copyEnderecoEntrega ? '100%' : '50%'
                            }"
                          >
                            <el-col>
                              <vEndereco 
                                v-model="dadosFormulario.empresa.endereco_entrega" 
                                ref="enderecoEntrega"
                              />
                            </el-col>
                          </div>
                        </el-col>
                      </el-row>

                    </b-card-body>
                  </b-card>
                </b-tab>

                <b-tab title="Configurações" title-item-class="bg-primary text-secondary">
                  <b-card header="Configurações e Financeiro">
                    <b-card-body>
                      <b-row>
                        <b-col cols="4">
                          <div class="form-group">
                            <label for="">Código Distribuidor:</label>
                            <input disabled="" type="text" class="form-control" v-model="dadosFormulario.configuracoes.codigo_distribuidor
                              " />
                          </div>
                        </b-col>
                        <b-col cols="4">
                          <div class="form-group">
                            <label for="">Pagamento:</label>
                            <select name="" id="" class="form-control" v-model="dadosFormulario.configuracoes.pagamento"
                              @change="changeTipoPagamento">
                              <option value="BOLETO">Boleto</option>
                              <option value="TRANSFERENCIA">Depósito</option>
                            </select>
                          </div>
                        </b-col>
                        <b-col cols="4" v-show="perfil === 'financeiro' || perfil === 'adm' || perfil === 'cobranca'">
                          <div class="form-group">
                            <label for="">Limite de Crédito:</label>
                            <input type="text" class="form-control" v-mask="[
                              '#',
                              '#.#',
                              '#.##',
                              '##.##',
                              '###.##',
                              '####.##',
                              '#####.##',
                              '######.##',
                              '#######.##',
                            ]" v-model="dadosFormulario.configuracoes.limite_credito
                              " />
                          </div>
                        </b-col>
                        <b-col cols="4" v-show="(perfil === 'financeiro' || perfil === 'adm' || perfil === 'cobranca') && dadosFormulario.configuracoes.classe_distribuidor === 'G'">
                          <div class="form-group">
                            <label for="">&nbsp;</label>
                            <b-form-checkbox v-model="dadosFormulario.configuracoes.cnae_pendente" switch>
                              Pendência de CNAE (fora do padrão)
                            </b-form-checkbox>
                          </div>
                        </b-col>
                      </b-row>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <b-form-group
                              description="Antes de selecionar o prazo, preencha o CEP da empresa no cadastro."
                              label="Prazo Pagamento:" label-for="prazo-pagamento">
                              <b-form-select id="prazo-pagamento" :disabled="showPrazosPagamento.length <= 1  ||
                                dadosFormulario.configuracoes.pagamento ===
                                'TRANSFERENCIA'
                                " v-model="dadosFormulario.configuracoes.prazo_pagamento" 
                                :options="showPrazosPagamento"></b-form-select>
                            </b-form-group>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="">Qtd. Revendedoras:</label>
                            <input type="text" class="form-control" v-mask="['####']" v-model="dadosFormulario.configuracoes.qtd_revendedoras
                              " />
                          </div>
                        </div>
                        <div class="col-md-4" v-if="
                          dadosFormulario.configuracoes.classe_distribuidor ==
                          'A' ||
                          dadosFormulario.configuracoes.classe_distribuidor ==
                          'P'
                        ">
                          <label>Cadastro Matriz</label>
                          <v-select v-model="matrizSelecionado" :options="listaDistribuidores" @search="buscaDistribuidor"
                            @change="selectMatriz" placeholder="Código do Distribuidor" v-mask="['#######']" :disabled="loadingBuscaDistribuidor ||
                              (dadosFormulario.configuracoes.status !==
                                'DIGITADO' &&
                                dadosFormulario.configuracoes.status !==
                                'PENDENTE') ||
                              dadosFormulario.configuracoes.tipo_cadastro !=
                              'NOVO'
                              ">
                            <div slot="no-options">
                              Nenhum distribuidor encontrado
                            </div>
                          </v-select>
                        </div>
                        <div class="col-md-4" dadosFormulario.configuracoes.classe_distribuidor v-if="
                          dadosFormulario.configuracoes.classe_distribuidor ===
                          'V'
                        ">
                          <div class="form-group">
                            <label for="port">Porte da Empresa:</label>
                            <b-form-select id="port" v-model="dadosFormulario.configuracoes.porte"
                              :options="optionsPorte"></b-form-select>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-3" v-show="show &&
                          dadosFormulario.configuracoes.classe_distribuidor !==
                          'L' &&
                          dadosFormulario.configuracoes.tipo_cadastro =='NOVO'
                          ">
                          <div class="checkbox">
                            <label><input type="checkbox" v-model="dadosFormulario.configuracoes.kit_super_credito
                              " />
                              Kit Super Crédito</label>
                          </div>
                        </div>
                        <!-- <div class="col-md-3" v-show="show &&
                          dadosFormulario.configuracoes.tipo_cadastro =='NOVO' &&
                          dadosFormulario.configuracoes.classe_distribuidor === 'L'"
                        >
                          <div class="checkbox">
                            <label><input type="checkbox" 
                              v-model="dadosFormulario.configuracoes.kit_cadastro" 
                              value="kit_cadastro" 
                              @change="validCheckCadastro" 
                            />
                              Kit Cadastro
                            </label>
                          </div>
                        </div>                      -->
                        <div class="col-md-3" v-show="show &&
                          dadosFormulario.configuracoes.tipo_cadastro =='NOVO' &&
                          (dadosFormulario.configuracoes.classe_distribuidor === 'A' ||
                            dadosFormulario.configuracoes.classe_distribuidor === 'G' ||
                            dadosFormulario.configuracoes.classe_distribuidor === 'L'
                          )"
                        >
                          <div class="checkbox">
                            <label>
                              <input type="checkbox" 
                                disabled
                                v-model="dadosFormulario.configuracoes.kit_personalizado" 
                                value="kit_personalizado" 
                                @change="validCheckCadastro" 
                              />
                              Kit Personalizado
                            </label>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="checkbox">
                            <label>
                              <input type="checkbox" v-model="dadosFormulario.configuracoes.ecommerce" />
                              Ecommerce
                            </label>
                          </div>
                        </div>
                      </div>

                      <b-row class="mt-3">
                        <b-col class="col-md-3">
                          <div class="form-group">
                            <label for=""></label>
                            <b-form-checkbox v-model="hasCatalogo">
                              Enviar Catálogos?
                            </b-form-checkbox>
                          </div>
                        </b-col>
                        <b-col class="col-md-3">
                          <div class="form-group" v-if="hasCatalogo">
                            <label for="">Qtd. Catálogo:</label>
                            <input type="text" class="form-control" v-mask="['######']"
                              v-model="dadosFormulario.configuracoes.qtd_catalogo" :readonly="readOnly" />
                          </div>
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>
                </b-tab>

                <b-tab title="Anexos" title-item-class="bg-primary text-secondary">
                  <b-card header="Anexos">

                  <div class="checkbox" v-if="(perfil === 'financeiro' || perfil === 'adm' || perfil === 'cobranca') && dadosFormulario.configuracoes.status === 'AGUARDANDO'">                            
                            <label><input type="checkbox" v-model="visaoAnexoLista" />
                              Lista</label>
                  </div>

                    <b-card-body v-if="visaoAnexoLista">
                        <div v-for="(anexo, index) in dadosFormulario.anexos" :key="anexo.id">
                          <div>
                            <a target="_blank" rel="noopener noreferrer" :href="anexo.url_arquivo">{{ anexo.descricao }}</a>
                            <div class="checkbox" v-if="(perfil === 'financeiro' || perfil === 'adm' || perfil === 'cobranca') && dadosFormulario.configuracoes.status === 'AGUARDANDO'">                            
                            <label><input type="checkbox" v-model="dadosFormulario.anexos[index].aprovado" />
                              Aprovado</label>
                            </div>
                            <br>
                            
                          </div>
                        </div>
                    </b-card-body>
                    <b-card-body v-else>
                      <div class="row" :class="{ 'opened-folder': anexoFolderOpened > 0 }">
                        <div class="text-right">
                          <b-button size="sm" v-show="anexoFolderOpened > 0" variant="secondary"
                            @click="setOpenedFolderAnexo(0)">
                            <i class="fa fa-arrow-circle-left"></i> Voltar p/
                            Pastas
                          </b-button>

                          <b-button size="sm" v-if="anexoFolderOpened > 0" variant="primary" class="mr-3" @click="addAnexo()">
                            <i class="fa fa-plus"></i> Adicionar novo Arquivo
                          </b-button>
                        </div>
                        <div class="section-card-folders">
                          <div 
                            v-if="anexoFolderOpened === 0" 
                            v-for="(tipoAnexo, idx) in tiposAnexos" 
                            :key="idx"
                            class="card-folder"
                            @click="setOpenedFolderAnexo(tipoAnexo.id)"
                          >
                            <i class="fa fa-folder fa-3x"></i>
                            <br />
                            {{ tipoAnexo.descricao }}
                            <span v-if="validaArquivo(tipoAnexo)" class="card-folder-required">*</span>
                          </div>
                        </div>

                        <div v-for="(anexo, index) in dadosFormulario.anexos" :key="anexo.id">
                          <div class="container-anexo" v-show="anexoFolderOpened === anexo.id_anexo">
                            <v-input-file ref="arquivosObrigatorios" name="Arquivo" :id="'file_input_' + index" type="pdf"
                              v-model="anexo.file" :fileURL="anexo.url_arquivo"
                              :extensions="anexo.tipos_aceitos.split(',')" @remove="deletarURL">
                              {{ anexo.descricao }}
                            </v-input-file>
                            <div class="checkbox" v-if="!tipoCadastro">                            
                            <label><input type="checkbox" v-model="dadosFormulario.anexos[index].aprovado" />
                              Aprovado</label>
                            </div>
                            <b-button variant="danger" class="mt-2" size="sm" @click="removeAnexo(index)">
                              <i class="fas fa-trash-alt"></i> Remover
                            </b-button>
                          </div>
                        </div>
                      </div>
                    </b-card-body>
                    <b-card-footer  v-if="!visaoAnexoLista">
                      <b-row>
                        <b-col>
                          <h6>Legenda:</h6>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <p class="text-primary">
                            Anexo Obrigatório:<strong class="text-danger" style="font-size: 20px">*</strong>
                          </p>
                        </b-col>
                      </b-row>
                    </b-card-footer>
                  </b-card>
                </b-tab>

                <b-tab title="Observações" title-item-class="bg-primary text-secondary">
                  <b-card>
                    <b-card-body>
                      <div class="row">
                        <div class="col-md-12 form-group">
                          <label for="">Novas Observações:</label>
                          <textarea name="" id="" cols="30" rows="5" class="form-control"
                            v-model="observacoes"></textarea>
                        </div>
                      </div>
                    </b-card-body>
                  </b-card>
                  <div class="row mt-4" v-for="(
                      observacao, keyObs
                    ) in dadosFormulario.prospectoObservacoes" :key="keyObs">
                    <div class="col-md-12">
                      <div class="card">
                        <div class="card-body">
                          <div class="observacoes">
                            <small>{{ observacao.created_at }}</small>
                            <span class="text-primary">{{
                              observacao.user.name
                            }}</span>
                            escreveu:
                            <div class="col-md-12">
                              {{ observacao.observacao }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>

                <b-tab title="Consulta SPC" title-item-class="bg-primary text-secondary" v-if="prospectoId > 0">
                  <b-card>
                    <b-card-body>
                      <div class="text-right float-right" style="margin-top: 10px; margin-right: 10px">
                        <b-button variant="danger" size="sm" @click="showModalSPC" v-if="prospectoId > 0">
                          Fazer nova Busca ao SPC
                        </b-button>
                      </div>
                      <div class="float-left">
                        <vConsultaReceitaFederal :cnpj="dadosFormulario.empresa.cnpj">
                        </vConsultaReceitaFederal>
                      </div>
                    </b-card-body>
                  </b-card>

                  <div class="row mt-4" v-for="(consulta, keyCon) in consultasSPC" :key="keyCon">
                    <div class="col-md-12">
                      <b-card>
                        <b-card-body>
                          Consultado por
                          <strong class="text-primary">{{
                            consulta.name
                          }}</strong>
                          em {{ formatDate(consulta.created_at) }}
                          <b-button :href="'/spc/' + consulta.id" variant="secondary" size="sm" class="ml-3"
                            target="_blank">
                            <i class="fas fa-list-alt"></i> Ver Consulta</b-button>
                        </b-card-body>
                      </b-card>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <b-modal v-model="saveFormulario" id="alertErro" role="dialog" size="lg" title="Erro">
        <b-card>
          <ul>
            <li v-for="(erro, e) in erros" :key="e">
              {{ erro }}
            </li>
          </ul>
        </b-card>
        <template #modal-footer>
          <b-button variant="primary" button-size="sm" @click="saveFormulario = false">
            Fechar
          </b-button>
        </template>
      </b-modal>

      <b-modal v-model="openModalSPC" size="lg" title="Consulta SPC" hide-footer>
        <b-card>
          <b-card-title>
            <h4 class="modal-title">Atenção</h4>
          </b-card-title>
          <b-card-body>
            Esta consulta gera Custos por Requisição, Deseja continuar?
          </b-card-body>
          <b-card-footer>
            <b-button :disabled="loadingConsulta" size="sm" variant="success" @click="consultaSPC('J'), openModalSPC">
              <b-spinner variant="secondary" v-if="loadingConsulta" small></b-spinner>
              <i class="fas fa-search-dollar" v-else></i>
              Sim, Consultar CNPJ</b-button>
            <b-button :disabled="loadingConsulta" size="sm" class="float-right" variant="danger"
              @click="showModalSPC">Cancelar</b-button>
          </b-card-footer>
        </b-card>
      </b-modal>

      <b-modal v-model="modalDuplicatas" title="Cadastros com Informações Coincidentes" size="lg">
        <p class="text-muted mb-3">
          Os cadastros abaixo possuem telefone ou endereço iguais ao deste cadastro.
        </p>
        <b-table
          :items="duplicatasEncontradas"
          :fields="[
            { key: 'id', label: 'ID' },
            { key: 'nome', label: 'Nome / Razão Social' },
            { key: 'codigo_distribuidor', label: 'Código' },
            { key: 'status', label: 'Status' },
            { key: 'coincidencia', label: 'Coincidência' },          
          ]"
          striped
          hover
          small
          responsive
          show-empty
          empty-text="Nenhum cadastro encontrado"
        >
          <template #cell(status)="row">
            <b-badge :variant="row.item.status === 'ATIVO' ? 'success' : row.item.status === 'INATIVO' ? 'danger' : 'warning'">
              {{ row.item.status }}
            </b-badge>
          </template>       
        </b-table>
        <template #modal-footer>
          <b-button variant="secondary" size="sm" @click="modalDuplicatas = false">Fechar</b-button>
        </template>
      </b-modal>

      <b-modal v-model="modalCd" title="Centro de Distribuição" hide-footer hide-header-close no-close-on-backdrop
        no-close-on-esc>
        <b-card>
          <b-row>
            <div class="form-group">
              <label for="">Selecione o Centro de Distribuição:</label>
              <b-form-select v-model="dadosFormulario.configuracoes.centro_distribuicao"
                :disabled="perfil === 'centro_distribuicao'" :options="listaCentroDistribuicao" @input="closeModalCd()"
                @change="() => {
                  setOptionsClasseDistribuidor();
                  validaRegiao();
                }
                  ">
              </b-form-select>
            </div>
          </b-row>
        </b-card>
      </b-modal>
    </div>
  </div>
</template>

<script>
import vContato from "./../util/Contato.vue";
import vEndereco from "./../util/Endereco.vue";
import vInputFile from "./../util/InputFile.vue";
import validateEmpresa from "./modules/validations/module_validate_empresa.js";
import getAnexos from "./modules/validations/module_anexos_para_formdata.js";
import vConsultaReceitaFederal from "./../util/ConsultaReceitaFederal.vue";

import { Form, FormItem, Input, Switch, CheckboxGroup, Checkbox, Row, Col, Button, Divider  } from "element-ui"


var validateInscricaoEstadual = require("inscricaoestadual");

export default {
  props: {
    criar: {
      type: Boolean,
      default: true,
    },
    propProspectoId: {
      type: Number,
      default: 0,
    },
    acao: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      invalidInscricao: false,
      visaoAnexoLista: false,
      loadingConsulta: false,
      indicanteSelecionado: null,
      loadingBuscaDistribuidor: false,
      hasCatalogo: false,
      viewCatalogos: false,
      loadingImport: false,
      perfil: "",
      countPerfil: 0,
      classesAtendidas: [],
      loading: false,
      anterior: null,
      pessoaFisica: {
        nome: "",
        cpf: "",
        rg: "",
        data_nasc: "",
        email: "",
      },
      tipoCadastro: false,
      optionsRadio: [
        { text: "Cadastro Pessoa Jurídica", value: false },
        { text: "Cadastro Pessoa Física", value: true },
      ],
      consultorValido: false,
      showOptionsConsultor: [],
      showOptionsGerente: [],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        precision: 2,
        masked: false,
      },
      optionsPorte: [
        { value: null, text: "Selecione o Porte da Empresa" },
        { value: "MINI", text: "Mini - Até 49 Lojas" },
        { value: "PEQUENA", text: "Pequena - 50 a 99 Lojas" },
        { value: "MEDIA", text: "Média - 100 a 999 Lojas" },
        { value: "GRANDE", text: "Grande - Mais de 1000 Lojas" },
      ],
      porte: null,
      listaOptionsClasse: [],
      readOnly: false,
      prazoPagamentos: [],
      prospectoId: this.propProspectoId,
      erros: [],
      loadingSave: false,
      regioes: [],
      tiposAnexos: [],
      observacoes: "",
      users: [],
      openModalSPC: false,
      saveFormulario: false,
      norteENordeste: [
        "AC",
        "AM",
        "RR",
        "AP",
        "PA",
        "RO",
        "TO",
        "BA",
        "SE",
        "AL",
        "PE",
        "PB",
        "RN",
        "CE",
        "PI",
        "MA",
      ],
      dadosFormulario: {
        codigo_representante: "",
        empresa: {
          cadastro_mei: false,
          assinado_gov: false,
          razao_social: "",
          cnpj: "",
          inscricao_estadual: "",
          nome_fantasia: "",
          contatos: [
            {
              descricao: "",
              tipo: "F",
              numero: "",
              whatsapp: 0,
            },
            {
              descricao: "",
              tipo: "F",
              numero: "",
              whatsapp: 0,
            },
          ],
          endereco: {
            cep: "",
            logradouro: "",
            bairro: "",
            estado: "",
            cidade: 0,
            complemento: "",
            instrucao_entrega:"",
          },
          endereco_entrega: {
            cep: "",
            logradouro: "",
            bairro: "",
            estado: "",
            cidade: 0,
            complemento: "",
            instrucao_entrega:"",
          },
        },
        proprietario: {
          nome: "SEM REFERENCIA",
          cpf: "00000000000",
          rg: "000",
          data_nasc: "01/01/2000",
          contatos: [
            {
              descricao: "SEM CONTATO",
              tipo: "F",
              numero: "0",
              whatsapp: 0,
            },
          ],
          email: "",
        },
        socios: [],
        testemunhas: [],
        referenciasPessoais: [],
        referenciasComerciais: [],
        configuracoes: {
          tipo_cadastro: "NOVO",
          prazo_pagamento: null,
          qtd_catalogo: 0,
          catalogo: false,
          classe_distribuidor: $("#centro_distribuicao").val() ? "G" : "A",
          pagamento: "BOLETO",
          kit_super_credito: false,
          kit_cadastro: false,
          kit_farmacia: false,
          kit_salao: false,
          kit_cadastro_revendedora: false,
          qtd_revendedoras: 0,
          regiao_id: 1,
          codigo_vendedor: "",
          user_id: 0,
          status: "DIGITADO",
          codigo_distribuidor: "",
          cd: false,
          centro_distribuicao: null,
          limite_credito: "0.00",
          codigo_anterior: null,
          ecommerce: false,
          pre_cadastro_id: 0,
          cnae_pendente: false,
        },
        disabled: false,
        anexos: [],
        observacoes: [],
      },
      codigo_representante: "",
      representantes: [],
      representante: "",
      errors: [],
      copyEnderecoEntrega: false,
      consultasSPC: [],
      anexoFolderOpened: 0,
      removedFiles: [],
      listaCentroDistribuicao: [],
      centrosDistribuicao: [],
      show: true,
      limite: false,
      novoStatus: null,
      modalCd: false,
      distribuidores: [],
      distribuidoresMatriz: [],
      matrizSelecionado: null,
      erroInscricao: '',
      loadingIsncricao: false,
      duplicatasEncontradas: [],
      loadingDuplicatas: false,
      modalDuplicatas: false,
    };
  },
  created() {
    if (this.acao == "import") {
      this.loadingImport = true;
    }
  },
  methods: {
    async verificarInscricaoEstadual(){
      this.loadingIsncricao = true;
      this.erroInscricao = ''
      this.invalidInscricao = true;

      if(!this.dadosFormulario.empresa.endereco.estado || !this.dadosFormulario.empresa.inscricao_estadual){
        this.erroInscricao = 'Selecione UF e Digite uma inscrição valida'
        this.loadingIsncricao = false;
        return
      }
      
      await axios
        .get(
          "/adm/prospecto/verificar-inscricao", {
            params: { 
              uf: this.dadosFormulario.empresa.endereco.estado,
              inscricao: this.dadosFormulario.empresa.inscricao_estadual
            }
          }
        )
        .then((response) => {
          if(response.data.data){
            this.invalidInscricao = false;
            this.erroInscricao = ''
          }else{
            this.erroInscricao = 'Inscrição estadual invalida!'
          }
        })
        .catch((erro) => {
          console.log(erro);
          this.erroInscricao = 'Erro ao verificar inscrição!'
        })
        .finally(() => {
          this.loadingIsncricao = false
        });
    },
    selectMatriz(obj) {
      if (typeof obj === "undefined" || typeof obj === "string" || !obj) {
        this.dadosFormulario.configuracoes.distribuidor_id_matriz = "";
      } else {
        this.dadosFormulario.configuracoes.distribuidor_id_matriz =
          typeof obj === "number" ? obj : obj.value;
      }
      this.distribuidores = [];
    },
    selectIndicante(obj) {
      if (typeof obj === "undefined" || typeof obj === "string" || !obj) {
        this.dadosFormulario.configuracoes.distribuidor_id_indicante = "";
      } else {
        this.dadosFormulario.configuracoes.distribuidor_id_indicante =
          typeof obj === "number" ? obj : obj.value;
      }
      this.distribuidores = [];
    },
    buscaDistribuidor(key) {
      if (key.length >= 4) {
        const vm = this;
        axios
          .get("/adm/distribuidor/buscar/" + key)
          .then((response) => {
            vm.distribuidores = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    removeAnterior() {
      this.dadosFormulario.configuracoes.codigo_anterior = null;
    },
    validaArquivo(item) {
      if (
        item.obrigatorio &&
        (item.descricao == "Cópia CPF" ||
          item.descricao == "Cópia RG" ||
          item.descricao == "Comprovante de Endereço" ||
          item.descricao == "Promissória" ||
          item.descricao == "Cartão CNPJ" ||
          item.descricao == "Vigilância Sanitária" ||
          item.descricao == "AFE" ||
          item.descricao == "DRE" ||
          item.descricao == "Balanço Patrimonial" ||
          item.descricao == "Faturamento" ||
          item.descricao == "Notas Fiscais"
        )
      ) {
        return true;
      } else if (
        this.tipoCadastro == false &&
        item.obrigatorio &&
        (item.descricao == "Contrato Social" ||
          item.descricao == "SINTEGRA" ||
          item.descricao == "Cópia Contrato")
      ) {
        return true;
      }
      return false;
    },
    setCd() {
      if (this.dadosFormulario.configuracoes.centro_distribuicao != 10) {
        this.tipoCadastro = false;
      }
      this.validaRegiao();
    },
    closeModalCd() {
      if (
        this.modalCd === true &&
        this.dadosFormulario.configuracoes.centro_distribuicao
      ) {
        this.modalCd = false;
      }
    },
    selectCD() {
      if (this.acao != "import") {
        this.modalCd = true;
      }
    },
    atualizarCadastro() {
      axios
        .post(
          "/distribuidor/solicita-atualizacao/" +
          this.dadosFormulario.configuracoes.codigo_distribuidor
        )
        .then((response) => {
          this.$swal.fire({
            text:
              "Solicitado ao distribuidor " +
              this.dadosFormulario.configuracoes.codigo_distribuidor +
              " a atualização do cadastro!",
            icon: "success",
            footer:
              "Será necessário o distribuidor preencher o formulário de atualização no próximo acesso!",
          });
        })
        .catch((erro) => {
          console.log(erro);
        });
    },
    verTodos() {
      window.location.href = "/adm/prospecto";
    },

    inativarCadastro() {
      this.novoStatus = "INATIVO";
      this.saveFormularios();
    },

    pendenciarCadastro() {
      this.novoStatus = "PENDENTE";
      this.saveFormularios();
    },

    validaRegiao() {
      if (this.perfil === "centro_distribuicao") {
        this.dadosFormulario.configuracoes.regiao_id = 10;
        this.dadosFormulario.configuracoes.centro_distribuicao = 10;
        return;
      }

      const opcoesRegiao = this.showRegioes || [];
      const regiaoAtual = parseInt(this.dadosFormulario.configuracoes.regiao_id);
      const possuiRegiaoAtual = opcoesRegiao.some(
        (regiao) => parseInt(regiao.id) === regiaoAtual
      );

      if (!possuiRegiaoAtual) {
        this.dadosFormulario.configuracoes.regiao_id = opcoesRegiao.length > 0
          ? parseInt(opcoesRegiao[0].id)
          : null;
      }
    },
    showClasse() {
      var data = false;
      if (this.dadosFormulario.configuracoes.centro_distribuicao === 1) {
        data = true;
      }
      return data;
    },

    showKit() {
      const vm = this;
      vm.showClasse();
      vm.limite = false;
      vm.show = true;
      if (
        vm.perfil === "representante_varejo" ||
        vm.perfil === "centro_distribuicao"
      ) {
        vm.show = false;
      }

      if (!vm.showClasse) {
        vm.show = false;
      }

      if (
        vm.dadosFormulario.configuracoes.classe_distribuidor === "V" ||
        vm.dadosFormulario.configuracoes.classe_distribuidor === "J" ||
        vm.dadosFormulario.configuracoes.classe_distribuidor === "H" ||
        vm.dadosFormulario.configuracoes.classe_distribuidor === "P"
      ) {
        vm.show = false;
        vm.dadosFormulario.configuracoes.kit_cadastro_revendedora = false;
        vm.dadosFormulario.configuracoes.kit_farmacia = false;
        vm.dadosFormulario.configuracoes.kit_salao = false;
        vm.dadosFormulario.configuracoes.kit_cadastro = false;
        vm.dadosFormulario.configuracoes.kit_personalizado = false;
      }
      if (
        vm.dadosFormulario.configuracoes.classe_distribuidor === "G" ||
        vm.dadosFormulario.configuracoes.classe_distribuidor === "A"
      ) {
        vm.dadosFormulario.configuracoes.kit_cadastro = false;
        vm.dadosFormulario.configuracoes.kit_farmacia = false;
        vm.dadosFormulario.configuracoes.kit_salao = false;
        vm.dadosFormulario.configuracoes.kit_personalizado = true;
        vm.dadosFormulario.configuracoes.kit_cadastro_revendedora = false;
      }

      if (vm.dadosFormulario.configuracoes.classe_distribuidor === "L") {
        vm.dadosFormulario.configuracoes.kit_cadastro = false;
        vm.dadosFormulario.configuracoes.kit_personalizado = true;
        vm.dadosFormulario.configuracoes.kit_cadastro_revendedora = false;
        vm.dadosFormulario.configuracoes.kit_super_credito = false;
        vm.dadosFormulario.configuracoes.kit_farmacia = false;
        vm.dadosFormulario.configuracoes.kit_salao = false;
      }

      if (vm.dadosFormulario.configuracoes.classe_distribuidor === "V") {
        vm.limite = true;
      }

      return vm.show, vm.limite;
    },

    setOptionsClasseDistribuidor(value) {
      var vm = this;
      if (value === undefined || typeof value === "undefined" || !value) {
        value = vm.dadosFormulario.configuracoes.centro_distribuicao;
      }
      vm.listaOptionsClasse = [
        {
          value: "G",
          text: "Classe Gestora",
        },
        {
          value: "A",
          text: "Classe Master",
        },
        {
          value: "V",
          text: "Classe Varejo",
        },
        {
          value: "L",
          text: "Classe L",
        },
        {
          value: "F",
          text: "Classe Farma",
        },
        {
          value: "J",
          text: "Classe J",
        },
        {
          value: "P",
          text: "Classe P",
        },
      ];

      if (!value || parseInt(value) === 1) {
        vm.dadosFormulario.configuracoes.cd = false;
      } else if (this.perfil == "coord_comercial" || this.perfil == "adm") {
        vm.dadosFormulario.configuracoes.cd = true;
      } else {
        vm.dadosFormulario.configuracoes.cd = true;
        vm.dadosFormulario.configuracoes.classe_distribuidor = "G";
      }
    },

    prazos(ibge) {
      const vm = this;
      vm.prazoPagamentos = [];
      const data = {
        ibge: ibge[0],
        uf: ibge[1],
      };
      axios
        .post("/adm/prazos-pagamento/regiao", data)
        .then((response) => {
          if (response.data) {
            if (vm.dadosFormulario.configuracoes.classe_distribuidor !== "L") {
              vm.prazoPagamentos = response.data["regiao"];
            }
          }
        })
        .catch((erro) => {
          console.log("erro ao buscar os prazos", erro);
        })
        .finally(() => { });
    },
    async getListaCentroDistribuicao() {
      const vm = this;
      let data = [];
      await axios
        .get("/adm/centros-distribuicao/pluck")
        .then((response) => {
          vm.centrosDistribuicao = response.data.data || [];
            data.push({
              value: null,
              text: "Selecione o CD",
            });
          vm.centrosDistribuicao.forEach((a) => {
            data.push({
              value: a.codigo,
              text: a.text,
            });
            vm.listaCentroDistribuicao = data;
          });
        })
        .catch((_err) => {
          console.log("Erro ao buscar lista de CD ", _err);
        })
        .finally(() => { });
    },
    normalizeFilialValue(value) {
      return String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toLowerCase();
    },
    parseFilialDistribuicao(value) {
      const FILIAIS_VALIDAS = ["matriz", "imperatriz", "manaus"];
      const texto = this.normalizeFilialValue(value);

      if (!texto) {
        return [];
      }

      return texto
        .split(",")
        .map((item) => this.normalizeFilialValue(item))
        .filter((item) => FILIAIS_VALIDAS.includes(item));
    },
    getFilialDistribuicaoByCentro() {
      const centroSelecionado = parseInt(this.dadosFormulario.configuracoes.centro_distribuicao);

      if (!centroSelecionado || !Array.isArray(this.centrosDistribuicao)) {
        return [];
      }

      const centro = this.centrosDistribuicao.find(
        (item) => parseInt(item.codigo) === centroSelecionado
      );

      if (!centro) {
        return [];
      }

      const descricao = this.normalizeFilialValue(centro.descricao);
      const estadoUF = this.normalizeFilialValue(
        centro.estado && centro.estado.uf ? centro.estado.uf : ""
      );
      const filiais = [];

      if (descricao.indexOf("manaus") > -1 ) {
        filiais.push("manaus");
      }

      if (descricao.indexOf("imperatriz") > -1 ) {
        filiais.push("imperatriz");
      }

      if (descricao.indexOf("matriz") > -1 || filiais.length === 0) {
        filiais.push("matriz");
      }

      return filiais;
    },

    getVendedor() {
      const vm = this;
      axios
        .get("/adm/prospecto/representante")
        .then((response) => {
          if (response.data) {
            vm.showOptionsConsultor = [
              {
                value: "",
                text: "Nenhum consultor selecionado",
              },
            ];
            vm.showOptionsGerente = [
              {
                value: "",
                text: "Nenhum gerente selecionado",
              },
            ];
            vm.representantes = [
              {
                value: "",
                text: "Nenhum representante selecionado",
              },
            ];
            let data = response.data;

            data.forEach((el) => {
              if (el.representante) {
                let dados = {};
                dados.value = el.codigo;
                dados.text = el.codigo + " - " + el.nome;
                vm.representantes.push(dados);
              } else {
                let dadosC = {};
                dadosC.value = el.codigo;
                dadosC.text = el.codigo + " - " + el.nome;
                vm.showOptionsConsultor.push(dadosC);
              }
              if (el.gerente) {
                let dadosG = {};
                dadosG.value = el.codigo;
                dadosG.text = el.codigo + " - " + el.nome;
                vm.showOptionsGerente.push(dadosG);
              }
            });

            if (
              vm.dadosFormulario.configuracoes.status === "DIGITADO" &&
              vm.representantes.length == 2 &&
              vm.representante === ""
            ) {
              vm.representante = vm.representantes[1].value;
            }
          }
        })
        .catch((erro) => {
          console.log("erro ao buscar vendedor", erro);
        });
    },
    checkImport() {
      if (this.acao && this.acao == "import") {
        this.loadingImport = true;
        let data = JSON.parse(localStorage.getItem("distribuidorIndicado"));
        this.dadosFormulario.configuracoes.centro_distribuicao = "1";
        this.dadosFormulario.empresa.cnpj = data.cnpj;
        this.dadosFormulario.proprietario.email = data.email;
        this.dadosFormulario.proprietario.nome = data.nome;
        this.dadosFormulario.configuracoes.pre_cadastro_id =
          data.precadastro_id;
        this.dadosFormulario.proprietario.contatos[0].numero = data.telefone;
        this.dadosFormulario.empresa.endereco.cep = String(data.cep);
        this.dadosFormulario.empresa.endereco.import = true;
        this.loadingImport = false;
      }
    },
    async init() {
      $(".loading").show();
      this.loading = true;
      this.loadRegioes();
      this.loadUsers();
      await this.getListaCentroDistribuicao();
      this.setOptionsClasseDistribuidor();
      this.getVendedor();
      this.showClasse();
      this.validaRegiao();
      await this.getPerfil();
      await this.loadClassesAtendidas();
      await this.loadTiposAnexos();
      await this.listConsultasSPC();
      this.loading = false;
      $(".loading").hide();
    },

    loadProspecto() {
      const vm = this;
      if (this.acao == "import") {
        this.createAnexos();
        this.checkImport();
        this.dadosFormulario.configuracoes.user_id = this.getUsuario();
        return;
      }
      if (this.propProspectoId === 0) {
        this.createAnexos();
        this.dadosFormulario.configuracoes.user_id = this.getUsuario();
        vm.selectCD();
        return;
      }
      axios
        .get("/adm/prospecto/show/" + this.propProspectoId)
        .then((response) => {
          let data = response.data;
          data.anexos = [];
          vm.dadosFormulario = Object.assign({}, data);
          if (vm.dadosFormulario) {
            if (
              vm.dadosFormulario.configuracoes.limite_credito == "0.00" ||
              vm.dadosFormulario.configuracoes.limite_credito == "0.0"
            ) {
              vm.dadosFormulario.configuracoes.limite_credito = "0.0";
            }
            if (vm.dadosFormulario.configuracoes.indicante && vm.dadosFormulario.configuracoes.indicante.id) {
              vm.distribuidores.push(vm.dadosFormulario.configuracoes.indicante);
              vm.indicanteSelecionado = {
                label: vm.dadosFormulario.configuracoes.indicante.codigo + " - " + vm.dadosFormulario.configuracoes.indicante.nome,
                value: vm.dadosFormulario.configuracoes.indicante.id,
              };
            }
            if (vm.dadosFormulario.configuracoes.matriz && vm.dadosFormulario.configuracoes.matriz.id) {
              vm.distribuidoresMatriz.push(vm.dadosFormulario.configuracoes.matriz);
              vm.matrizSelecionado = {
                label: vm.dadosFormulario.configuracoes.matriz.codigo + " - " + vm.dadosFormulario.configuracoes.matriz.nome,
                value: vm.dadosFormulario.configuracoes.matriz.id,
              };
            }
            vm.changeTipoPagamento();
            vm.createAnexos();
            vm.showKit();
            if (vm.dadosFormulario.empresa.endereco_entrega.cep.length < 8) {
              vm.copyEnderecoEntrega = true;
            }
            if (vm.dadosFormulario.configuracoes.classe_distribuidor === "L") {
              vm.dadosFormulario.configuracoes.qtd_catalogo = 0;
              vm.readOnly = true;
            } else {
              vm.readOnly = false;
            }
            vm.representante = data.vendedor ? data.vendedor.codigo : "";
            vm.tipoCadastro =
              vm.dadosFormulario.configuracoes.tipo_pessoa_fisica;
            if (
              vm.dadosFormulario.configuracoes.qtd_catalogo &&
              vm.dadosFormulario.configuracoes.qtd_catalogo > 0
            ) {
              vm.hasCatalogo = true;
            } else {
              vm.hasCatalogo = false;
            }
            vm.consultorIsValid();
            vm.verificarDuplicatas();
            if (
              !vm.dadosFormulario ||
              !vm.dadosFormulario.configuracoes.centro_distribuicao
            ) {
              vm.selectCD();
            }
          }
        })
        .catch((error) => {
          console.log(error);
          var errors = error.response.data.errors;
          if (typeof errors === "object") {
            alert(errors.join("\n"));
          } else if (typeof errors === "string") {
            alert(errors);
          } else {
            alert("Falha ao gravar dados.");
          }
          console.log(error.response);
        })
        .finally(() => { });
    },

    validCheckCadastro(event) {
      var vm = this;
      var value = event.target.value;
      var checked = event.target.checked;

      if (
        this.dadosFormulario.configuracoes.classe_distribuidor === "H" ||
        this.dadosFormulario.configuracoes.classe_distribuidor === "V" ||
        this.dadosFormulario.configuracoes.classe_distribuidor === "J" ||
        this.dadosFormulario.configuracoes.classe_distribuidor === "P"
      ) {
        vm.dadosFormulario.configuracoes.kit_cadastro = false;
        vm.dadosFormulario.configuracoes.kit_cadastro_revendedora = false;
        vm.dadosFormulario.configuracoes.kit_farmacia = false;
        vm.dadosFormulario.configuracoes.kit_salao = false;
        vm.dadosFormulario.configuracoes.kit_personalizado = false;
        return;
      } else if (value === "kit_cadastro") {
        if (checked === true) {
          vm.dadosFormulario.configuracoes.kit_cadastro = true;
          vm.dadosFormulario.configuracoes.kit_cadastro_revendedora = false;
          vm.dadosFormulario.configuracoes.kit_farmacia = false;
          vm.dadosFormulario.configuracoes.kit_salao = false;
          vm.dadosFormulario.configuracoes.kit_personalizado = false;
        } else {
          vm.dadosFormulario.configuracoes.kit_cadastro_revendedora = false;
          vm.dadosFormulario.configuracoes.kit_cadastro = true;
          vm.dadosFormulario.configuracoes.kit_farmacia = false;
          vm.dadosFormulario.configuracoes.kit_salao = false;
          vm.dadosFormulario.configuracoes.kit_personalizado = false;
        }
      } else if (value === "kit_personalizado") {
        if (checked === true) {
          vm.dadosFormulario.configuracoes.kit_cadastro = false;
          vm.dadosFormulario.configuracoes.kit_cadastro_revendedora = false;
          vm.dadosFormulario.configuracoes.kit_farmacia = false;
          vm.dadosFormulario.configuracoes.kit_salao = false;
          vm.dadosFormulario.configuracoes.kit_personalizado = true;
        } else {
          vm.dadosFormulario.configuracoes.kit_cadastro_revendedora = false;
          vm.dadosFormulario.configuracoes.kit_cadastro = false;
          vm.dadosFormulario.configuracoes.kit_farmacia = false;
          vm.dadosFormulario.configuracoes.kit_salao = false;
          vm.dadosFormulario.configuracoes.kit_personalizado = false;
        }
      } else {
        vm.dadosFormulario.configuracoes.kit_cadastro = true;
        vm.dadosFormulario.configuracoes.kit_cadastro_revendedora = false;
        vm.dadosFormulario.configuracoes.kit_farmacia = false;
        vm.dadosFormulario.configuracoes.kit_salao = false;
        vm.dadosFormulario.configuracoes.kit_personalizado = false;
      }
    },

    async loadUsers() {
      var vm = this;
      let data = {
        prospecto: true,
      };
      await axios
        .get("/adm/users/list", { params: data })
        .then((response) => {
          vm.users = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => { });
    },
    async loadRegioes() {
      var vm = this;
      await axios
        .get("/regiao")
        .then((response) => {
          vm.regioes = response.data;
        })
        .catch((error) => {
          alert("Falha ao carregar Regiões.");
          console.log(error);
        })
        .finally(() => { });
    },
    async loadTiposAnexos() {
      var vm = this;
      await axios
        .get("/adm/anexos_para_prospectos/listar")
        .then((response) => {
          vm.tiposAnexos = response.data;
          vm.loadProspecto();
        })
        .catch((error) => {
          alert("Falha ao carregar Regiões.");
          console.log(error);
        })
        .finally(() => { });
    },

    async saveFormularios() {
      const vm = this;
      this.loadingSave = true;
      const formValid = await this.formIsValide()
      if (!formValid) {
        vm.saveFormulario = true;
        this.loadingSave = false;
        return;
      } else {
        if (
          this.dadosFormulario.configuracoes.classe_distribuidor === "V" ||
          this.dadosFormulario.configuracoes.classe_distribuidor === "J" ||
          this.dadosFormulario.configuracoes.classe_distribuidor === "H" ||
          this.dadosFormulario.configuracoes.classe_distribuidor === "P" ||
          this.dadosFormulario.configuracoes.tipo_cadastro === "MIGRACAO" ||
          this.dadosFormulario.configuracoes.tipo_cadastro === "REATIVACAO"
        ) {
          vm.dadosFormulario.configuracoes.kit_cadastro = false;
          vm.dadosFormulario.configuracoes.kit_cadastro_revendedora = false;
          vm.dadosFormulario.configuracoes.kit_farmacia = false;
          vm.dadosFormulario.configuracoes.kit_salao = false;
          vm.dadosFormulario.configuracoes.kit_personalizado = false;
        }
        if (vm.dadosFormulario.configuracoes.limite_credito) {
          vm.dadosFormulario.configuracoes.limite_credito = parseFloat(
            vm.dadosFormulario.configuracoes.limite_credito.replace(/\D/g, "") /
            100
          ).toFixed(2);
        }

        this.dadosFormulario.codigo_representante = this.representante;
        vm.dadosFormulario.configuracoes.novoStatus = this.novoStatus
          ? this.novoStatus
          : null;
        this.dadosFormulario.observacoes = this.observacoes;
        this.dadosFormulario.configuracoes.tipoCadastro = this.tipoCadastro;
        if (!vm.hasCatalogo) {
          vm.dadosFormulario.configuracoes.qtd_catalogo = 0;
        }

        $(".loading").show();
        axios
          .post("/adm/prospecto", this.dadosFormulario)
          .then((response) => {
            vm.prospectoId = response.data.id;
            vm.saveAnexos();
          })
          .catch((error) => {
            var errors = error.response.data.errors;

            if (typeof errors === "object") {
              alert(errors.join("\n"));
            } else if (typeof errors === "string") {
              alert(errors);
            } else {
              alert("Falha ao gravar dados.");
            }

            console.log(error.response);
          })
          .finally(() => {
            $(".loading").hide();
            this.loadingSave = false;
          });
      }
    },

    ativaCadastro() {
      if (
        !this.dadosFormulario.configuracoes.limite_credito ||
        this.dadosFormulario.configuracoes.limite_credito == ""
      ) {
        this.$swal.fire({
          title: "Atenção",
          text: "Informe o limite de crédito",
          icon: "warning",
        });
        return;
      }
      this.novoStatus = "ATIVO";
      this.saveFormularios();
    },

    saveAnexos() {
      $(".loading").show();
      let data = getAnexos(this.dadosFormulario.anexos);
      data.append("prospecto_id", this.prospectoId);
      data.append("delete", this.removedFiles);
      axios
        .post("/adm/prospecto_anexo", data)
        .then((response) => {
          window.location.href = "/adm/prospecto";
        })
        .catch((error) => {
          var errors = error.response.data.errors;

          if (typeof errors === "object") {
            alert(errors.join("\n"));
          } else if (typeof errors === "string") {
            alert(errors);
          } else {
            alert("Falha ao gravar dados.");
          }
          console.log(error.response);
        })
        .finally(() => {
          $(".loading").hide();
        });
    },
    fechar() {
      window.location.href = "/adm/prospecto";
    },
    async consultaSPC(tipo_pessoa) {
      const vm = this;

      let data = {
        tipo_pessoa: tipo_pessoa,
        id_prospecto: this.prospectoId,
      };
      vm.loadingConsulta = true;
      await axios
        .post("/spc", data)
        .then((response) => {
          window.open("/spc/" + response.data.id, "_blank");
          vm.listConsultasSPC();
        })
        .catch((error) => {
          var errors = error.response.data.errors;
          if (typeof errors === "object") {
            alert(errors.join("\n"));
          } else if (typeof errors === "string") {
            alert(errors);
          } else {
            alert("Falha na consulta.");
          }
          console.log(error.response);
        })
        .finally(() => {
          vm.loadingConsulta = false;
        });
    },
    async listConsultasSPC() {
      var vm = this;
      await axios
        .get("/spc/list?prospecto_id=" + this.prospectoId)
        .then((response) => {
          vm.consultasSPC = response.data;
        })
        .catch((error) => {
          var errors = error.response.data.errors;
          if (typeof errors === "object") {
            alert(errors.join("\n"));
          } else if (typeof errors === "string") {
            alert(errors);
          } else {
            alert("Falha na consulta.");
          }
          console.log(error.response);
        })
        .finally(() => { });
    },
    async formIsValide() {
      this.erros = [];

      await this.verificarInscricaoEstadual()

      if(this.invalidInscricao){
        this.erros.push("Inscrição Estadual Invalida ou Não preenchida!");
        return false;
      }

      if (!this.tipoCadastro && !this.empresaIsValid()) {
        return false;
      }

      if(this.dadosFormulario.configuracoes.prazo_pagamento == null){
        this.erros.push("Prazo de Pagamento não inserido!");
        return false
      }

      if (!this.configurationsIsValid()) {
        return false;
      }

      if (!this.consultorIsValid()) {
        return false;
      }

      if (this.dadosFormulario.configuracoes.classe_distribuidor === "V" && this.perfil !== "gerente_regional") {
        if (!this.validaRepresentante()) {
          return false;
        }
      }
      if (
        (this.dadosFormulario.configuracoes.tipo_cadastro == "MIGRACAO" || this.dadosFormulario.configuracoes.tipo_cadastro == "REATIVACAO") &&
        !this.dadosFormulario.configuracoes.codigo_anterior
      ) {
        this.erros.push("Código Anterior Inválido");
        return false;
      }

      return true;
    },

    consultorIsValid() {
      const vm = this;
      let consultor = null;
      if (
        vm.dadosFormulario.configuracoes.codigo_vendedor &&
        vm.dadosFormulario.configuracoes.codigo_vendedor !== ""
      ) {
        consultor = vm.showOptionsConsultor.filter(
          (el) => vm.dadosFormulario.configuracoes.codigo_vendedor == el.value
        );
      }

      if (!consultor || consultor.length < 1) {
        vm.erros.push("Código do consultor inválido");
      } else {
        vm.consultorValido = true;
        return true;
      }
      vm.consultorValido = false;
      return false;
    },

    validaRepresentante() {
      if (this.representante && this.representante !== "") {
        return true;
      } else {
        this.erros.push("Código do representante inválido");
        return false;
      }
    },
    empresaIsValid() {
      let empresa = this.dadosFormulario.empresa;
      let erros = validateEmpresa(empresa);

      let contatosEmpresa = this.$refs["contatoEmpresa"];

      contatosEmpresa.forEach((contato) => {
        if (!contato.isValid()) {
          erros.push("Contato Inválido");
          return;
        }
      });

      if (!this.$refs["enderecoEmpresa"].isValid()) {
        erros.push("Endereco Inválido");
      }

      if (
        !this.$refs["enderecoEntrega"].isValid() &&
        !this.copyEnderecoEntrega
      ) {
        erros.push("Endereco de Entrega Inválido");
      }

      if (erros.length > 0) {
        this.erros = erros;
      }

      return erros.length === 0;
    },

    configurationsIsValid() {
      let configs = this.dadosFormulario.configuracoes;
      if (
        this.dadosFormulario.configuracoes.classe_distribuidor === "V" &&
        !this.dadosFormulario.configuracoes.porte
      ) {
        this.erros.push("Selecione o porte da empresa!");
        return false;
      }
      if (configs.regiao_id <= 0) {
        this.erros.push("Selecione a Região!");
        return false;
      }
      if (!this.dadosFormulario.configuracoes.centro_distribuicao) {
        this.erros.push("Selecione o Centro de Distribuição!");
        return false;
      }
      if (
        this.hasCatalogo &&
        (!this.dadosFormulario.configuracoes.qtd_catalogo ||
          this.dadosFormulario.configuracoes.qtd_catalogo == "" ||
          parseInt(this.dadosFormulario.configuracoes.qtd_catalogo) <= 0) &&
        !this.dadosFormulario.configuracoes.ecommerce &&
        (this.dadosFormulario.configuracoes.classe_distribuidor == "G" ||
          this.dadosFormulario.configuracoes.classe_distribuidor == "A")
      ) {
        this.erros.push("Informe a Quantidade de Catálogos");
        return false;
      }
      return true;
    },

    addContato(contato) {
      contato.push({
        tipo: "F",
        numero: "",
        whatsapp: 0,
      });
    },
    deleteContatoEmpresa(index) {
      this.removeContato(index, this.dadosFormulario.empresa.contatos);
    },
    removeContato(index, contato) {
      contato.splice(index, 1);
    },
    copiarEnderecoParaEntrega(event) {
      if (!event.target.checked) {
        return;
      }

      this.dadosFormulario.empresa.endereco_entrega = Object.assign(
        {},
        this.dadosFormulario.empresa.endereco
      );
    },
    createAnexos() {
      if (typeof this.dadosFormulario.prospectoAnexos === "undefined") {
        return;
      }
      for (let anexo of this.dadosFormulario.prospectoAnexos) {
        let path = anexo.path.replace("public", "storage");
        let url = path.length > 0 ? "/" + path : "";
        let tipoAnexo = this.getTipoAnexoByid(anexo.anexo_para_prospecto_id);
        let obj = {
          id: anexo.id,
          id_anexo: tipoAnexo.id,
          descricao: tipoAnexo.descricao,
          file: null,
          obrigatorio: tipoAnexo.obrigatorio,
          tipos_aceitos: tipoAnexo.extensoes,
          aprovado : anexo.aprovado,
          url_arquivo: url,
        };

        this.dadosFormulario.anexos.push(Object.assign({}, obj));
      }
    },
    getAnexoByIdProspectoAnexo(id) {
      if (typeof this.dadosFormulario.prospectoAnexos === "undefined") {
        return "";
      }

      for (let anexo of this.dadosFormulario.prospectoAnexos) {
        if (anexo.anexo_para_prospecto_id === id) {
          let url = anexo.path.replace("public", "storage");
          return url.length > 0 ? "/" + url : "";
        }
      }
      return "";
    },
    deletarURL(id) {
      let idAnexo = id.replace("file_input_", "");
      this.removeAnexo(idAnexo);
    },
    async getPerfil() {
      const vm = this;
      if (!vm.perfil || (vm.perfil == "" && vm.countPerfil <= 0)) {
        this.countPerfil++;
        await axios
          .get("/my-profile")
          .then((response) => {
            vm.perfil = response.data.profile.roles[0].name;
          })
          .catch((erro) => {
            console.log(erro);
            alert(erro);
          });
      } else if (!vm.perfil || vm.perfil == "") {
        vm.perfil = $("#perfil").val();
      }
      if (vm.perfil) {
        if (
          vm.perfil !== "adm" &&
          vm.perfil !== "gestor" &&
          vm.perfil !== "financeiro" &&
          vm.perfil !== "centro_distribuicao" &&
          vm.perfil !== "representante_varejo" &&
          vm.perfil !== "list_prospecto" &&
          vm.perfil !== "comercial" &&
          vm.perfil !== "coord-comercial" &&
          vm.perfil !== "coord_comercial" &&
          vm.perfil !== "supervisor_externo" &&
          vm.perfil !== "diretor_nacional" &&
          vm.perfil !== "gerente_nacional" &&
          vm.perfil !== "gerente_regional" &&
          vm.perfil !== "gerente_distrital" &&
          vm.perfil !== "coordenador_externo" &&
          vm.perfil !== "analista_farma" &&
          vm.perfil !== "preposto" &&
          vm.perfil !== "cobranca"
        ) {
          alert("Perfil de Usuário não Encontrado");
          window.location = "/adm";
        }
      }
      if (vm.perfil === "centro_distribuicao") {
        this.dadosFormulario.configuracoes.cd = true;
        this.dadosFormulario.configuracoes.classe_distribuidor = "G";
      }

      if (vm.perfil === "representante_varejo" && !this.dadosFormulario.id) {
        // this.dadosFormulario.configuracoes.codigo_vendedor = 330
      }
      return vm.perfil;
    },
    async loadClassesAtendidas() {
      try {
        const response = await axios.get("/my-profile");
        this.classesAtendidas = response.data.profile.classes_atendidas || [];
      } catch (erro) {
        console.log(erro);
        this.classesAtendidas = [];
      }

      // Em um novo cadastro, a classe padrão precisa ser uma das atendidas pelo usuário
      const classeAtual = this.dadosFormulario.configuracoes.classe_distribuidor;
      if (
        !this.dadosFormulario.id &&
        this.showOptionsClasse.length > 0 &&
        !this.showOptionsClasse.some((opcao) => opcao.value === classeAtual)
      ) {
        this.dadosFormulario.configuracoes.classe_distribuidor = this.showOptionsClasse[0].value;
      }
    },
    getUsuario() {
      return $("#id_usuario").val();
    },
    getRolesUser(roles) {
      var tmpRoles = [];
      roles.forEach((roles) => {
        tmpRoles.push(roles.label);
      });
      return tmpRoles.join(",");
    },
    changeTipoPagamento() {
      if (this.dadosFormulario.configuracoes.pagamento === "TRANSFERENCIA") {
        this.dadosFormulario.configuracoes.prazo_pagamento = 0;
      }
      if (
        this.dadosFormulario.empresa.endereco.cidade.cidade &&
        this.dadosFormulario.empresa.endereco.estado
      ) {
        this.prazos([
          this.dadosFormulario.empresa.endereco.cidade,
          this.dadosFormulario.empresa.endereco.estado,
        ]);
      }
    },
    showModalSPC() {
      this.openModalSPC = !this.openModalSPC;
    },
    changeTipoCadastro(tipo) {
      if (tipo == "NOVO") {
        this.dadosFormulario.configuracoes.kit_cadastro = true;
      } else {
        this.dadosFormulario.configuracoes.kit_cadastro = false;
        this.dadosFormulario.configuracoes.kit_cadastro_revendedora = false;
      }
    },

    formatDate(date) {
      let momentObj = moment(date, "YYYY-MM-DD hh:mm:ss");
      return momentObj.format("DD/MM/YYYY hh:mm:ss");
    },
    addAnexo() {
      let tipoAnexo = this.getTipoAnexo();
      let obj = {
        id: 0,
        id_anexo: this.anexoFolderOpened,
        descricao: tipoAnexo.descricao,
        file: null,
        obrigatorio: tipoAnexo.obrigatorio,
        tipos_aceitos: tipoAnexo.extensoes,
        aprovado : false,
        url_arquivo: "",
      };

      this.dadosFormulario.anexos.push(Object.assign({}, obj));
    },
    setOpenedFolderAnexo(id) {
      this.anexoFolderOpened = id;
    },
    getTipoAnexo() {
      for (let tipoAnexo of this.tiposAnexos) {
        if (tipoAnexo.id === this.anexoFolderOpened) {
          return tipoAnexo;
        }
      }
    },
    getTipoAnexoByid(id) {
      for (let anexo of this.tiposAnexos) {
        if (anexo.id == id) {
          return anexo;
        }
      }
    },
    removeAnexo(index) {
      let idAnexo = this.dadosFormulario.anexos[index].id;

      if (idAnexo > 0) {
        this.removedFiles.push(idAnexo);
      }

      this.dadosFormulario.anexos.splice(index, 1);
    },
    getRole() {
      return $("#role").val();
    },

    async verificarDuplicatas() {
      if (!this.prospectoId || this.prospectoId <= 0) return;
      this.loadingDuplicatas = true;
      await axios
        .get('/adm/prospecto/' + this.prospectoId + '/duplicatas')
        .then((response) => {
          this.duplicatasEncontradas = response.data || [];
        })
        .catch((erro) => {
          console.log('Erro ao verificar duplicatas', erro);
        })
        .finally(() => {
          this.loadingDuplicatas = false;
        });
    },
  },
  watch: {
    prospectoId(newValue) {
      this.listConsultasSPC();
    },
    "dadosFormulario.configuracoes.classe_distribuidor": {
      immediate: true,
      handler (value) {
        this.showPrazosPagamento;
        this.showKit();
      },
    },
    "dadosFormulario.configuracoes.prazo_pagamento": function (val) {
      if (
        val &&
        this.dadosFormulario.empresa.endereco.cidade &&
        this.dadosFormulario.empresa.endereco.estado
      ) {
        this.prazos([
          this.dadosFormulario.empresa.endereco.cidade,
          this.dadosFormulario.empresa.endereco.estado,
        ]);
      }
    },
    "dadosFormulario.empresa.endereco": {
      deep: true,
      handler(value) {
        if (this.copyEnderecoEntrega) {
          this.dadosFormulario.empresa.endereco_entrega = Object.assign(
            {},
            value
          );
        }
      },
    },
  },
  computed: {
    listaDistribuidores() {
      var _distribuidores = [];
      if (this.distribuidores.length > 0) {
        this.distribuidores.map((el) => {
          _distribuidores.push({
            label: el.codigo + " - " + el.nome,
            value: el.id,
          });
        });
      }
      return _distribuidores;
    },
    viewQtd() {
      return this.dadosFormulario.configuracoes.catalogo;
    },
    showRegioes() {
      const filiais = this.getFilialDistribuicaoByCentro();

      const data = this.regioes.filter((regiao) => {
        const filiaisRegiao = this.parseFilialDistribuicao(regiao.filial_distribuicao);

        if (filiaisRegiao.length === 0 || filiais.length === 0) {
          return true;
        }

        return filiaisRegiao.some((filial) => filiais.includes(filial));
      });

      return data.map((el) => ({
        ...el,
        label: `${el.nome} - ${el.descricao}`,
      }));
    },
    showOptionsClasse() {
      const classeAtual = this.dadosFormulario.configuracoes.classe_distribuidor;
      // Classe F não está mais disponível para novos cadastros; mantida apenas para prospectos que já a possuem
      return this.listaOptionsClasse.filter(
        (opcao) =>
          (opcao.value !== "F" || classeAtual === "F") &&
          // Usuário com classes atendidas só pode cadastrar prospectos dessas classes
          (this.classesAtendidas.length === 0 || this.classesAtendidas.includes(opcao.value) || opcao.value === classeAtual)
      );
    },

    showPrazosPagamento() {
      let data = [{value: null, text: "Selecione um prazo"}]
      if (this.dadosFormulario.configuracoes.classe_distribuidor === "V") {
        data = [
          {
            value: null,
            text: "Selecione um prazo"
          },
          {
            value: "0",
            text: "A Vista",
          },
          {
            value: "1",
            text: "Consignado",
          },
          {
            value: "30",
            text: "30 Dias ",
          },
          {
            value: "20",
            text: "20/30/40 Dias",
          },
          {
            value: "40",
            text: "40/50 Dias",
          },
          {
            value: "60",
            text: "30/45/60 Dias",
          },
        ];
        if (
          this.dadosFormulario.empresa.endereco.estado == "AM" ||
          this.dadosFormulario.empresa.endereco.estado == "RO"
        ) {
          data.push({ value: "75", text: "75 Dias" });
          data.push({ value: "76", text: "65/75/85 Dias" });
        }
      } else if (
        this.dadosFormulario.configuracoes.classe_distribuidor === "L"
      ) {
        if (
          this.norteENordeste.includes(
            this.dadosFormulario.empresa.endereco.estado
          )
        ) {
          data = [
            {
              value: null,
              text: "Selecione um prazo"
            },
            {
              value: "0",
              text: "A Vista",
            },
            {
              value: "45",
              text: "45 Dias",
            },
            {
              value: "60",
              text: "30/45/60 Dias",
            },
          ];
        } else {
          data = [
            {
              value: null,
              text: "Selecione um prazo"
            },
            {
              value: "0",
              text: "A Vista",
            },

            {
              value: "30",
              text: "30 Dias ",
            },
            {
              value: "20",
              text: "20/30/40 Dias",
            },
          ];
        }
      } else {
        this.prazoPagamentos.forEach((item) => {
          data.push({
            value: parseInt(item.codigo_protheus),
            text: item.descricao,
          });
        });
      }
      return data;
    },

    isValidInscricaoEstadual() {
      return true;
      var inscricaoEstadual = this.dadosFormulario.empresa.inscricao_estadual;

      if (inscricaoEstadual.length < 3) {
        return false;
      }

      return validateInscricaoEstadual(inscricaoEstadual) !== false;
    },
    anexosAprovados(){
      var retorno = true
      this.dadosFormulario.anexos.forEach(function(a, index) {
        
        if(!a.aprovado){
          retorno= false;
        }
      });

      return retorno;
    },
    isNorteOuNordesteBrasileiro() {
      let estado = this.dadosFormulario.empresa.endereco.estado;
      if (this.norteENordeste.indexOf(estado) >= 0) {
        return true;
      }

      return false;
    },
  },
  async mounted() {
    const elLoading = this.$loading({ lock: true })

    await this.init();
    
    elLoading.close();
  },
  components: {
    vContato: vContato,
    vEndereco: vEndereco,
    vInputFile: vInputFile,
    vConsultaReceitaFederal: vConsultaReceitaFederal,
    [Button.name]: Button,
    [Divider.name]: Divider
  },
};
</script>

<style lang="scss" scoped>
.nav-tabs{
  .active{
    color: #5A7DA3 !important;
  }
  
  a{
    color: rgb(89, 0, 0) !important;
  }
}

.panel-heading>span {
  float: right;
  color: #ff666a;
}

.btn-remove-contato {
  margin-top: 25px;
}

.btn-plus-revendedora {
  margin-bottom: 30px;
}

.error {
  border: solid 1px #f00;
}

.content-input-file {
  margin: 0px !important;
}

.container-anexo {
  float: left;
  padding: 10px;
  text-align: center;
}

.section-card-folders {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 12px;
  width: 100%;
}

.card-folder {
  grid-column: span 3 / span 3;
  position: relative;
  padding: 12px;
  font-size: 1rem;
  cursor: pointer;
  text-align: center;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: 1px dashed #dedede;
}

.card-folder:hover {
  border-color: #1E90f4;
  color: #1E90f4;
}

.card-folder-required {
  position: absolute;
  right: 12px;
  font-size: 24px;
  top: 0px;
  color: #ff666a;
}

.opened-folder {
  border: solid 1px #ccc;
  padding: 9px 2px;
}

@media (max-width: 768px) {
  .card-folder {
    grid-column: span 6 / span 6;
    font-size: 14px;
  }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/adm_prospecto/Create.vue